import { render } from "./unifiedMode.vue?vue&type=template&id=29d0a525&scoped=true&ts=true"
import script from "./unifiedMode.vue?vue&type=script&lang=ts"
export * from "./unifiedMode.vue?vue&type=script&lang=ts"

import "./unifiedMode.vue?vue&type=style&index=0&id=29d0a525&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d0a525"]])

export default __exports__